import { useCallback } from 'react';

import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { useCqrsFindHealthcareProviderNfzConfiguration } from './useCqrsFindNfzConfiguration';

const NFZ_CENTRAL_DEPARTMENT_CODE: NfzDepartment['code'] = '17';

type NfzConfigurationNecessaryCheckerReturnFn = () => boolean;

export const useNfzConfigurationNecessaryChecker = (): NfzConfigurationNecessaryCheckerReturnFn => {
   const { data, fetched } = useCqrsFindHealthcareProviderNfzConfiguration();

   return useCallback(() => fetched && Boolean(!data || data.nfzDepartment.code === NFZ_CENTRAL_DEPARTMENT_CODE), [
      fetched,
      data,
   ]);
};
